





















import { Component, Vue, Prop } from "vue-property-decorator";
import TopBarMember from "@/components/TopBarMember.vue";
import LottoSetMenu from "@/components/LottoSetMenu.vue";

@Component({
  components: {
    TopBarMember,
    LottoSetMenu
  }
})
export default class LotterySet extends Vue {
  @Prop({ type: String })
  page!: string;
  constructor() {
    super();
    console.log(this.page);
  }
}
